import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '../AuthContext';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import UserStatus from './UserStatus';
import API from '../api';
import PublicRoute from '../PublicRoute';


function Home() {
    const { user } = useAuth();
    const [data, setData] = useState([]);
    const [deleted, setDeleted] = useState(true);
 
return (<PublicRoute>
<div className="page-container">
      <div className="content-wrap">
  <section className="navbar-area navbar-one">
    <div className="container">
      <div className="row">
        <div className="col-lg-12">
          <nav className="navbar navbar-expand-lg">
            <a className="navbar-brand" href="/">
              <img width = "200" height = "70" src={require("../images/logo.png")} alt="Logo" />
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
              aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
              <span className="toggler-icon"></span>
            </button>

            <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
              <ul className="navbar-nav m-auto">
                <li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>                
              </ul>
            </div>
            <div className="navbar-btn">
               <UserStatus />
            </div>
          </nav>
        </div>
      </div>
    </div>
  </section>

  <section id="hero-area" className="header-area header-ten">
    <div className="header-inner">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 co-12">
            <div className="home-slider">
              <div className="header-text">
                <h1 style = {{color: '#002F6C', fontWeight: '600', fontFamily: 'Poppins, sans-serif', fontSize:'42px', marginTop:'30px'}}>
                  Tracking Stock Prices Was Never So Easy 
                </h1>
                <ul style={{ fontSize: '20px', fontWeight: 'bold', paddingLeft: '20px', listStyleType: 'disc', color: '#333' }}>
                  <li>Set desired buy and sell prices for your stocks.</li>
                  <li>Get instant alerts over Telegram / SMS when your stock hits your target price.</li>
                  <li>Get news alert from authentic sources and much more.</li>
                </ul>
                <div className="light-rounded-buttons">
                  <a style = {{margin: '5px'}}href="/signup" className="btn primary-btn"> Free Trial </a>
                  <a style = {{margin: '5px'}} href="/pricing" className="btn primary-btn"> Compare Plans </a>
                </div>
              </div>
            </div>
          </div>
          <div className="col-lg-6 col-12">
            <div className="header-image">
                  <a href="/signup" className="overlay-link"></a>
              <img className="shape3" src={require("../images/shape3.png")} alt="#" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section className="about-area about-three">
    <div className="container">
      <div className="row">
        <div className="col-lg-6">
          <div className="about-feature-three">
            <div className="about-feature-image">
                            <div className="responsive-container">

              <img src={require("../images/about-image.jpg")} alt="About Image" className="responsive-image"/>
          <a href="/signup" className="responsive-button"></a>
       </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="about-feature-items-three">
            <ul>
              <li>
                <span className="number">1</span>
                <div className="content">
                  <h4 className="list-title">Instant Stock Alerts</h4>
                  <p>No need to check stock price every 5 minutes. Get notified via Telegram/SMS</p>
                </div>
              </li>
              <li>
                <span className="number">2</span>
                <div className="content">
                  <h4 className="list-title">Set Custom Buy & Sell Prices</h4>
                  <p>Select your stocks and set your desired buying and selling prices. Get notified when prices hit</p>
                </div>
              </li>
              <li>
                <span className="number">3</span>
                <div className="content">
                  <h4 className="list-title">No Missed Opportunities</h4>
                  <p>With stock prices fluctuating getting notified helps maximize profit</p>
                </div>
              </li>
                            <li>
                <span className="number">4</span>
                <div className="content">
                  <h4 className="list-title">Secure and Simple to Use</h4>
                  <p>No Apps to install. All you need is Signup to get started</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
</div>
</PublicRoute>
)
}

export default Home